import { sendInfrastructureAnalytics } from '../utils';

export const trackInfrastructureInModalSelect = (infrastructureType: string) => {
  sendInfrastructureAnalytics({
    action: 'click_block_object',
    infrastructureType,
  });
};
